import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

export function ErrorState({ title = "Something went wrong", message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4">
        <AlertTriangle className="h-8 w-8 text-red-400" />
      </div>
      <h3 className="text-lg font-medium text-slate-900 mb-1">{title}</h3>
      {message && <p className="text-sm text-slate-500 mb-4 max-w-md">{message}</p>}
      {onRetry && <Button onClick={onRetry} variant="outline" size="sm">Try again</Button>}
    </div>
  );
}
